import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";
import { ThaiDatePicker } from "thaidatepicker-react";
import { ConvertDate } from "../../pages/Function/ConvertDate";

const NewThaiDatePicker = (props) => {

  const {
    task = 0,
    value,
    setValue = null,
    maxDate = null,
    minDate = null,
    name=null,
    placeholderText = "",
    defaultValue = null,
    invalidProps = false,
    requireProps = false,
    showDateFormat = "DD/MM/YYYY",
    rounded = "rounded-2",
    showClearButton = false,
    returnType = null,
    disabled = false
  } = props;

  dayjs.locale("th")

  const headerButtonClassName = "btn btn-light border border-dark-subtle rounded-2 py-0"
  
  return (
    <div>
        <ThaiDatePicker
            value={value}
            defaultValue={defaultValue ?? undefined}
            // className = "z-5 position-absolute"
            header={{
                prevButtonClassName: headerButtonClassName,
                nextButtonClassName: headerButtonClassName
            }}
            minDate = {minDate || undefined}
            maxDate = {maxDate || undefined}
            placeholder={placeholderText}
            onChange={(christDate) => {setValue !== null && setValue(returnType === "DateTime" ? new Date(new Date(christDate).setHours(0,0,0,0)) : christDate)}}
            customInput={Input}
            inputProps={{
              name: name,
              displayFormat: showDateFormat,
              className: `btn-light border ${invalidProps ? "border-danger" : "border-secondary-subtle"} ${rounded}`,
              readOnly: true,
              invalid: invalidProps,
              require: requireProps,
              disabled: disabled
            }}
            clearable = {showClearButton}
        />
    </div>
    );
  };

export default NewThaiDatePicker